<!--(leafletMapReady)="onMapReady($event)"-->
<div leaflet
     [leafletOptions]="options"
     (leafletMapReady)="onMapReady($event)"
     (leafletMapZoomEnd)="onMapZoomEnd($event)"
     id='dialog-mapM2'
>
</div>
